import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Openaccount.css';

const OpenAccount = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    { number: 1, title: 'Register', description: 'Fill out our simple application form with your personal details' },
    { number: 2, title: 'Verify', description: 'Upload your ID and proof of address for verification' },
    { number: 3, title: 'Fund', description: 'Deposit funds using your preferred payment method' },
    { number: 4, title: 'Trade', description: 'Start trading on your live account with 2000+ instruments' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span>
          <span>Back to Home</span>
        </button>

        <h1>Open an Account</h1>
        <p className="subtitle">Start trading in 4 simple steps. Open your account today and access global markets within minutes.</p>

        <div className="steps-container">
          {steps.map((step) => (
            <div key={step.number} className="step-card">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>

        <div className="form-section">
          <h2>Ready to Get Started?</h2>
          <p className="form-description">Click the button below to register and start your trading journey with BGI Assets.</p>
          <Link to="/register" className="registration-button">
            Register Now
          </Link>
        </div>

        <div className="requirements">
          <h3>Requirements for Account Opening</h3>
          <ul>
            <li>Valid government-issued ID (Passport, Driver's License, or National ID)</li>
            <li>Proof of address (Utility bill, Bank statement - not older than 3 months)</li>
            <li>Minimum age of 18 years</li>
            <li>Valid email address and phone number</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OpenAccount;